import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("User_Token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 401 handler
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.clear();
      localStorage.clear();
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }

    //   if (error.status === 403) {
    //     // user data clear mat karo
    //     if (!window.location.pathname.includes("/pricing")) {
    //       alert("Your subscription plan has expired. Please renew to continue.");
    //       window.location.href = "/pricing";
    //     }
    //   }
    //   return Promise.reject(error);

    if (error.response?.status === 403) {
      if (!window.location.pathname.includes("/pricing")) {
        toast.error(
          "Your subscription plan has expired. Please renew to continue.",
        );

        setTimeout(() => {
          window.location.href = "/pricing";
        }, 2000);
      }
    }

    return Promise.reject(error);
  },
);

export const loginService = (submissionData) =>
  axios.post(`${baseUrl}/user/login`, submissionData);

export const getUserById = (id) => axios.post(`${baseUrl}/user/${id}`);

export const getUserPlan = () => axios.post(`${baseUrl}/user/getUserPlan`);

export const verifyOtpService = async (data) => {
  return axios.post(`${baseUrl}/user/verify-otp`, data);
};
export const verifyPin = async (data) => {
  return axios.post(`${baseUrl}/user/verify-pin`, data);
};
export const updateUser = async (id, data) => {
  return axios.post(`${baseUrl}/user/update/${id}`, data);
};
export const registerService = (submissionData) =>
  axios.post(`${baseUrl}/user/register`, submissionData);
export const dashboardSummary = () => axios.get(`${baseUrl}/dashboard/summary`);

export const createBusiness = (payload, config) =>
  axios.post(`${baseUrl}/business/create`, payload, config);
//createbby me

export const addBusiness = (submissionData) =>
  axios.post(`${baseUrl}/business/create`, submissionData);

export const updateBusiness = (id, submissionData) =>
  axios.post(`${baseUrl}/business/update/${id}`, submissionData);

export const deleteBusiness = (id) =>
  axios.post(`${baseUrl}/business/delete/${id}`);

export const getAllBusiness = (userId) =>
  axios.post(`${baseUrl}/business/getAllBusiness`, { userId });

export const getBusinessById = (id) =>
  axios.get(`${baseUrl}/business/getBusinessById/${id}`);

export const switchBusiness = async (submissionData) => {
  return await axios.post(
    `${baseUrl}/business/switch-business`,
    submissionData,
  );
};

// Parties API
export const getParties = (filters = {}) =>
  axios.post(`${baseUrl}/party/getAllParties`, filters, {});

export const searchParties = (filters = {}) =>
  axios.get(`${baseUrl}/party/search-party`, { params: filters });

export const bulkCheckPartyName = (data) =>
  axios.post(`${baseUrl}/party/bulk-check-name`, data);

export const bulkAddParties = (data) =>
  axios.post(`${baseUrl}/party/bulk-add-parties`, data);

export const addParty = (submissionData) =>
  axios.post(`${baseUrl}/party/addparty`, submissionData);

export const updateParty = (id, submissionData) =>
  axios.post(`${baseUrl}/party/update/${id}`, submissionData);

export const getSingleParty = (id) =>
  axios.post(`${baseUrl}/party/getparty/${id}`);

export const deleteParty = (id) => axios.post(`${baseUrl}/party/delete/${id}`);

// Purchase API
export const createPurchase = (submissionData) =>
  axios.post(`${baseUrl}/purchase/createpurchase`, submissionData);

export const updatePurchase = (id, submissionData) =>
  axios.post(`${baseUrl}/purchase/updatepurchase/${id}`, submissionData);

export const getAllPurchase = (filters = {}) =>
  axios.post(`${baseUrl}/purchase/getpurchase`, filters);

export const getSinglePurchase = (id) =>
  axios.post(`${baseUrl}/purchase/getSinglePurchase/${id}`);

export const deletePurchase = (id) =>
  axios.post(`${baseUrl}/purchase/deletepurchase/${id}`);

export const createReturnPurchase = (submissionData) =>
  axios.post(`${baseUrl}/return/purchasereturn`, submissionData);

export const getReturnPurchase = (submissionData) =>
  axios.post(`${baseUrl}/return/getpurchasereturn`, submissionData);
export const deletePurchaseReturn = async (id) => {
  try {
    const response = await axios.post(
      `${baseUrl}/return/deletepurchasereturn/${id}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getPurchaseReturnById = (id) => {
  return axios.post(`${baseUrl}/return/getpurchasereturnbyid/${id}`);
};
// purchase Order
export const getAllPurchaseOrders = (params = {}) =>
  axios.get(`${baseUrl}/purchaseorder/getallpurchaseorder`, { params });

export const getSinglePurchaseOrder = (id) =>
  axios.post(`${baseUrl}/purchaseorder/${id}`);

export const createPurchaseOrder = (submissionData) =>
  axios.post(`${baseUrl}/purchaseorder`, submissionData);
export const updatePurchaseOrder = (id, submissionData) =>
  axios.post(`${baseUrl}/purchaseorder/update/${id}`, submissionData);
export const deletePurchaseOrder = (id) =>
  axios.delete(`${baseUrl}/purchaseorder/${id}`);

// Stock Increase
export const addStockService = async (id, qty) => {
  return axios.post(`${baseUrl}/product/${id}/add-stock`, { quantity: qty });
};

// Sale API
//export const addSale = (submissionData) =>
//axios.post(`${baseUrl}/sale/createsale`, submissionData, {
//  headers: {
//    "Content-Type": "multipart/form-data",
// },
//});

//i corrected this code

//export const addSale = (submissionData) =>
//axios.post(`${baseUrl}/sales/create/:id`, submissionData);

export const addSale = (submissionData) =>
  axios.post(`${baseUrl}/sale/createsale`, submissionData);

export const updateSale = (id, submissionData) =>
  axios.post(`${baseUrl}/sale/update/${id}`, submissionData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getAllSale = (payload = {}) => {
  return axios.get(`${baseUrl}/sale/getsale`, { params: payload.query });
};
export const getSingleSale = (id) =>
  axios.post(`${baseUrl}/sale/getSingleSale/${id}`);

export const deleteSale = (id) => axios.post(`${baseUrl}/sale/delete/${id}`);

export const createSaleReturn = (submissionData) => {
  return axios.post(`${baseUrl}/return/salereturn`, submissionData);
};

export const getSaleReturn = (submissionData) =>
  axios.post(`${baseUrl}/return/getsalereturn`, submissionData);

export const getSaleReturnById = (id) => {
  return axios.post(`${baseUrl}/return/getsalereturnbyid/${id}`);
};
export const deleteSaleReturn = (id) => {
  return axios.post(`${baseUrl}/return/deletesalereturn/${id}`);
};

// Create Sale Order
export const getAllSaleOrders = (params = {}) =>
  axios.get(`${baseUrl}/saleorder/getallsaleorder`, { params });
export const getSingleSaleOrder = (id) =>
  axios.get(`${baseUrl}/saleorder/${id}`);
export const createSaleOrder = (submissionData) =>
  axios.post(`${baseUrl}/saleorder`, submissionData);
export const updateSaleOrder = (id, submissionData) =>
  axios.post(`${baseUrl}/saleorder/${id}`, submissionData);
export const deleteSaleOrder = (id) =>
  axios.delete(`${baseUrl}/saleorder/${id}`);

// Transactions API
export const getTransaction = (payload) =>
  axios.post(`${baseUrl}/ledger/getledger`, payload);

export const getLedgerDetails = (payload) =>
  axios.post(`${baseUrl}/ledger/detail`, payload);

export const deleteLedger = (id) =>
  axios.post(`${baseUrl}/ledger/deleteLedger/${id}`);

export const deleteAllTransactions = (submissionData) =>
  axios.post(`${baseUrl}/ledger/deleteAllTransactions`, submissionData);

export const getCollectionReport = (submissionData) =>
  axios.post(`${baseUrl}/ledger/getCollectionReport`, submissionData);

export const getPartyDetails = (partyId, params) =>
  axios.get(`${baseUrl}/party/getparty/${partyId}/gettransactions`, {
    params: params,
  });
// Stock transaction
export const getStockTransaction = (productId, page = 1, limit = 10) => {
  return axios.post(
    `${baseUrl}/stock/getStock/${productId}?page=${page}&limit=${limit}`,
  );
};

// Items API
export const addItem = (submissionData) =>
  axios.post(`${baseUrl}/product/createproduct`, submissionData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getItems = (params = {}) =>
  axios.get(`${baseUrl}/product/getproduct`, { params });

export const searchProduct = (params = {}) =>
  axios.get(`${baseUrl}/product/searchproduct`, { params });

export const deleteItem = (id) =>
  axios.post(`${baseUrl}/product/deleteproduct/${id}`);

export const updateItem = (id, submissionData) =>
  axios.post(`${baseUrl}/product/updateproduct/${id}`, submissionData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getItemById = (id) =>
  axios.post(`${baseUrl}/product/detail/${id}`);

export const generateCodes = (data) =>
  axios.get(`${baseUrl}/product/generate-codes`, {
    params: data,
  });
export const bulkCheckProductCodes = (data) =>
  axios.post(`${baseUrl}/product/bulk-check-codes`, data);

export const bulkAddProducts = (data) =>
  axios.post(`${baseUrl}/product/bulk-add-products`, data);

export const checkCodes = (submissionData) =>
  axios.post(`${baseUrl}/product/check-codes`, submissionData);

// categories
export const getCategories = (submissionData) => {
  return axios.post(`${baseUrl}/category`, submissionData);
};
export const addCategory = (submissionData) => {
  return axios.post(`${baseUrl}/category/addcategory`, submissionData);
};

export const updateCategory = (id, submissionData) => {
  return axios.post(`${baseUrl}/category/update/${id}`, submissionData);
};

export const deleteCategory = (id) => {
  return axios.delete(`${baseUrl}/category/delete/${id}`);
};

export const getCategoryById = (id) => {
  return axios.post(`${baseUrl}/category/${id}`);
};

// Locations

export const getLocations = (submissionData) => {
  return axios.post(`${baseUrl}/location`, submissionData);
};

export const addLocation = (submissionData) => {
  return axios.post(`${baseUrl}/location/add`, submissionData);
};

export const updateLocation = (id, submissionData) => {
  return axios.post(`${baseUrl}/location/update/${id}`, submissionData);
};

export const deleteLocation = (id) => {
  return axios.delete(`${baseUrl}/location/delete/${id}`);
};

export const getLocationById = (id) => {
  return axios.post(`${baseUrl}/location/${id}`);
};

// unit
export const getUnits = (submissionData) => {
  return axios.post(`${baseUrl}/unit`, submissionData);
};
export const addUnit = (submissionData) => {
  return axios.post(`${baseUrl}/unit/add`, submissionData);
};

export const deleteUnit = (id) => {
  return axios.delete(`${baseUrl}/unit/delete/${id}`);
};

export const getUnitById = (id) => {
  return axios.post(`${baseUrl}/unit/${id}`);
};

export const updateUnit = (id, submissionData) => {
  return axios.post(`${baseUrl}/unit/update/${id}`, submissionData);
};

export const getPrefix = (type = "") => {
  const params = {};
  if (type) params.type = type;

  return axios.get(`${baseUrl}/prefix/getprefix`, { params });
};

// Add a new prefix
export const addPrefix = (submissionData) => {
  return axios.post(`${baseUrl}/prefix/addprefix`, submissionData);
};
export const updatePrefix = (id, submissionData) => {
  return axios.post(`${baseUrl}/prefix/${id}`, submissionData);
};
export const deletePrefix = (id) => {
  return axios.delete(`${baseUrl}/prefix/${id}`);
};

// Payment-In API
export const createPaymentIn = (submissionData) => {
  return axios.post(`${baseUrl}/payment/createpayment-in`, submissionData);
};

export const getpaymentIn = (submissionData) => {
  axios.post(`${baseUrl}/payment/getpayment-in`, submissionData);
};
export const deletePaymentIn = (id) =>
  axios.post(`${baseUrl}/payment/deletepayment-in/${id}`);

// Payment-Out API
export const createPaymentOut = (submissionData) => {
  return axios.post(`${baseUrl}/payment/createpayment-out`, submissionData);
};

export const getpaymentOut = (submissionData) => {
  axios.post(`${baseUrl}/payment/getpayment-out`, submissionData);
};
export const deletePaymentOut = (id) =>
  axios.post(`${baseUrl}/payment/deletepayment-out/${id}`);

export const forgotPasswordService = (submissionData) =>
  axios.post(`/admin/forgotPassword`, submissionData);

export const postCustomer = (submissionData) =>
  axios.post(`/postcustomer`, submissionData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Settlement
export const makeSettlement = (submissionData) => {
  return axios.post(`${baseUrl}/payment/settlement`, submissionData);
};

// Expenses
export const getAllExpenses = (submissionData) => {
  return axios.post(`${baseUrl}/expense/getexpense`, submissionData);
};

export const addExpenses = (submissionData) => {
  return axios.post(`${baseUrl}/expense/addexpense`, submissionData);
};

export const deleteExpense = (id) => {
  return axios.delete(`${baseUrl}/expense/${id}`);
};

export const getExpenseById = (id) => {
  return axios.post(`${baseUrl}/expense/${id}`);
};

export const updatedExpense = (id, submissionData) => {
  return axios.post(`${baseUrl}/expense/update/${id}`, submissionData);
};

// Services

export const getAllServices = (queryString = "") => {
  return axios.get(`${baseUrl}/services/getservices${queryString}`);
};
export const bulkCheckServiceCodes = (data) =>
  axios.post(`${baseUrl}/services/bulk-check-codes`, data);

export const bulkAddServices = (data) =>
  axios.post(`${baseUrl}/services/bulk-add-services`, data);

export const addService = (submissionData) => {
  return axios.post(`${baseUrl}/services/addservice`, submissionData);
};

export const deleteService = (id) => {
  return axios.delete(`${baseUrl}/services/${id}`);
};

export const getServiceById = (id) => {
  return axios.post(`${baseUrl}/services/${id}`);
};

export const updatedService = (id, submissionData) => {
  return axios.post(`${baseUrl}/services/update/${id}`, submissionData);
};

// export const getSaleReportHistory = (submissionData) => {
//   return axios.get(`${baseUrl}/report/sale`, {
//     params: submissionData,
//   });
// };

// Reports

// export const getSaleReportHistory = (submissionData) => {
//   return axios.get(`${baseUrl}/report/product`, {
//     params: submissionData,
//   });
// };

export const ReportHistory = (submissionData) => {
  return axios.get(`${baseUrl}/report/ReportHistory`, {
    params: submissionData,
  });
};

export const getDashboardReport = (submissionData) => {
  return axios.post(`${baseUrl}/report/dashboard`, submissionData);
};
export const getDashboard = (submissionData) => {
  return axios.get(`${baseUrl}/dashboard/getDashboard`, submissionData);
};

export const getTopItems = (submissionData) => {
  return axios.post(`${baseUrl}/report/top-items`, submissionData);
};

export const getProductReport = (submissionData) => {
  return axios.get(`${baseUrl}/report/product`, {
    params: submissionData,
  });
};

export const getSaleReport = (submissionData) => {
  return axios.get(`${baseUrl}/report/sale`, {
    params: submissionData,
  });
};

export const getPurchaseReport = (submissionData) => {
  return axios.get(`${baseUrl}/report/purchase`, {
    params: submissionData,
  });
};

export const getItemReport = (submissionData) => {
  return axios.get(`${baseUrl}/report/item`, {
    params: submissionData,
  });
};

export const getledger = (submissionData) => {
  return axios.get(`${baseUrl}/report/transaction`, {
    params: submissionData,
  });
};

export const getPartyReport = (submissionData) => {
  return axios.get(`${baseUrl}/report/party-report`, {
    params: submissionData,
  });
};

export const getExpense = (submissionData) => {
  return axios.get(`${baseUrl}/report/expense`, {
    params: submissionData,
  });
};

export const downloadReport = (fileName) => {
  const token = localStorage.getItem("User_Token"); // <-- use correct key
  return axios.get(`${baseUrl}/report/downloadReport?fileName=${fileName}`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`, // send token in header
    },
  });
};

// shift
export const getAllShifts = (submissionData) =>
  axios.post(`${baseUrl}/shift/get`, submissionData);

export const addShift = (submissionData) =>
  axios.post(`${baseUrl}/shift/add`, submissionData);

export const getShiftById = (id, submissionData) =>
  axios.post(`${baseUrl}/shift/${id}`, submissionData);

export const updateShift = (id, submissionData) =>
  axios.post(`${baseUrl}/shift/update/${id}`, submissionData);

export const deleteShift = (id) =>
  axios.delete(`${baseUrl}/shift/delete/${id}`);

// employee
export const getAllEmployee = (submissionData) => {
  return axios.post(`${baseUrl}/employee/get`, submissionData);
};

export const addEmployee = (submissionData) =>
  axios.post(`${baseUrl}/employee/add`, submissionData);

export const getEmployeeById = (id, submissionData) =>
  axios.post(`${baseUrl}/employee/${id}`, submissionData);

export const updateEmployee = (id, submissionData) =>
  axios.post(`${baseUrl}/employee/update/${id}`, submissionData);

export const deleteEmployee = (id) =>
  axios.delete(`${baseUrl}/employee/delete/${id}`);

// attendance
export const addAttendance = (submissionData) =>
  axios.post(`${baseUrl}/attendance/add`, submissionData);

export const getAttendance = (submissionData) =>
  axios.post(`${baseUrl}/attendance/get`, submissionData);

export const getAttendanceById = (id) =>
  axios.post(`${baseUrl}/attendance/${id}`);

// Return api
export const getReturns = (params) =>
  axios.get(`${baseUrl}/return`, {
    params,
  });

// Subscription
export const takeSubscription = (submissionData) =>
  axios.post(`${baseUrl}/subscription`, submissionData);

export const confirmSubscription = (submissionData) =>
  axios.post(`${baseUrl}/subscription/confirm`, submissionData);

export const getPlans = () => axios.post(`${baseUrl}/admin/plan/getplans`);
